import { render, staticRenderFns } from "./RedButton.vue?vue&type=template&id=acb53ab8"
import script from "./RedButton.vue?vue&type=script&lang=ts"
export * from "./RedButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports